import styled from "styled-components";

export const Container = styled.select`
  background-color: ${({ theme: { colors } }) => colors.wildSand};
  border: 1px solid ${({ theme: { colors } }) => colors.silverSand};
  border-radius: 4px;
  padding: 5px;
`;
